// export const baseUrl2="apis/";
export const baseUrl2="https://api.createszjc.com/";  //"http://101.201.81.161:9002/";
// export const baseUrl2="http://192.168.33.240:8008/";  //"http://101.201.81.161:9002/";
//export const baseUrl2="http://localhost:9002/apis/";
export const baseUrl="http://39.105.114.156:8082/api/";
export const api = {

    /**
     * @deprecated PC端 视图
     * @author zyf
     */

    // 用户登录注册
    "userLogin" : baseUrl2 + "api/auth/login", // 登录
    "useCaptchaApi": baseUrl2 + "api/auth/captcha",  // 字母验证码
    "userLogout" : baseUrl2 + "api/auth/logout", // 注销账号
    "userGetOauthConfig" : baseUrl + "user/get_oauth_config", // 获取OAUTH
    "userRegister" : baseUrl2 + "api/auth/register", // 注册
    "userForgetPassword" : baseUrl + "user/forget_password", // 忘记密码
    "userRegCaptcha" : baseUrl + "auth/regCaptcha", // 发送短信
    "userResetPwd" : baseUrl2+"api/auth/forget", //重置密码-zyf
    "modifyPawwword": baseUrl2+"api/auth/password", // 修改密码
    "userInfo": baseUrl2+'api/auth/info',  // 获取用户信息接口
    "sendcode": baseUrl2+'api/auth/send/code',  //发送短信验证码
    "varifycode": baseUrl2 + "api/auth/verify/mobile",  //验证手机验证码
    //"userSendEmail" : baseUrl + "user/send_email", // 发送邮件 

    "homeGetUserInfo" : baseUrl + "user/get_user_info",// 获取用户信息
    "homeAuthInfo" : baseUrl + "api/auth/info",// 用户信息
    "homeAuthProfile" : baseUrl2 + "api/auth/update",// 修改用户信息
    // "homeCheckPayPassword" : baseUrl + "user/check_pay_password",// 验证支付密码
    //"homeCollectList" : baseUrl + "collect/list",// 修改收藏关注列表
    "addordeleteFav" : baseUrl + "collect/addordelete",// 删除收藏关注
    // "homeGetMoneyLog" : baseUrl + "user/get_money_log",// 获取用户资金变更日志
    //"homeAvatar" : baseUrl + "user/avatar",// 用户头像上传
    

    // 邀请信息
    //"homeGetInviterInfo" : baseUrl + "user/get_inviter_info",// 用户头像上传

    // 认证信息
    // "homeGetUserCheckInfo" : baseUrl + "user/get_user_check_info",// 获取用户认证信息
    // "homeEditUserCheckInfo" : baseUrl + "user/edit_user_check_info",// 修改用户认证信息
    // "homeUserCard" : baseUrl + "user/user_card",// 身份证上传

    // 首页接口
    // "homeGetSubNavInfo" : baseUrl + "index/get_subnav_info", // 获取首页左侧导航的信息
    // "homeGetIndexInfo" : baseUrl + "index/get_index_info", // 获取首页信息
    //"homeGetSubNavInfo" : baseUrl + "catalog/all", // 获取首页左侧导航的信息
    "getHomePageInfo" : baseUrl2 + "api/home/index", // 获取首页信息

    "getSolutionPageList" : baseUrl2 + "api/solution/page",
    "getSolutionDetail" : baseUrl2 + "api/solution/detail",

    // 栏目接口channel
    "getSubChannelList" : baseUrl2+"api/channel/sub",
    // 文章栏目接口
    "getArticlePageList" : baseUrl2+"api/article/page",
    "getArticleDetail" : baseUrl2+"api/article/detail",
    "getArticleTopList" : baseUrl2+"api/article/top",
    "getArticleLimitList" : baseUrl2+"api/article/limit",
    // 文章栏目接口
    "getJobPageList" : baseUrl2+"api/job/page",
    "getJobDetail" : baseUrl2+"api/job/detail",
    "getJobCategoryList" : baseUrl2+"api/job/category",
    "getJobJiPinList" : baseUrl2+"api/job/jipin",


    "getProductCategoryTree" : baseUrl2+"mall/category/tree", 
    "getProductIndustryTree" : baseUrl2+"mall/industry/tree",
    "getIndustryRelationTree": baseUrl2+"mall/industry/list/relation/",
    "getProductIndustryList": baseUrl2+"mall/product/list2",
    "getProductsApi": baseUrl2+'mall/product/menu',
    //"homeGetCategoryList" : baseUrl + "category/list", 
    // "getProductCategoryFilterList" : baseUrl2 + "mall/category/filter/", 
    "getProductCategoryFilterList" : baseUrl2 + "mall/category/filterByCategory", 

    //"homeGetIndustryTree" : baseUrl + "industry/tree", 
    //"homeGetIndustryList" : baseUrl + "industry/list", 
    //"industryFilterList" : baseUrl + "industry/list/relation", 

    //"homeGetFootInfo" : baseUrl + "index/get_foot_info", // 获取公共底部信息

    // 秒杀接口
    //"homeGetSeckillList" : baseUrl + "seckill/get_seckill_list", // 获取秒杀

    // 商家入驻
    //"homeStoreJoin" : baseUrl + "user/join", 
    //"homeGetJoinIndexAdv" : baseUrl + "index/get_join_index_adv", // // 获取加入我们幻灯片
    //"homeIsStore" : baseUrl + "store/is_store", // // 获取加入我们幻灯片

    // 商品详情
    // "homeGetGoodsInfo" : baseUrl + "goods/get_goods_info",
    "getProductDetail" : baseUrl2+ "mall/product/info",
    "searchGoodsByKeyword" : baseUrl2+"mall/search/list",
    //"homeSearchGoods" : baseUrl + "goods/search_goods",
    "searchProductByCategory" : baseUrl2+ "mall/product/list1",
    
    //"homeSearchGoodsByIndustry" : baseUrl + "goods/list2",
    //"searchGoodsByKeyword" : baseUrl + "goods/search",
    "getBrandList" : baseUrl + "brand/list",
    "getPurposeList" : baseUrl + "purpose/list",
    'getCommentList' : baseUrl + "comment/list",  // 获取评论列表根据商品ID

    // 收藏接口
    "myIsFav" : baseUrl + "fav/is_fav",
    //"myEditFav" : baseUrl + "fav/edit_fav",

    

    // 关联产品
    //"getRelationList" : baseUrl + "goods/relation",
    // 商品销售排行
    //"homeGetSaleList" : baseUrl + "goods/get_sale_list",

    // 购物车
    "addCart" : baseUrl2 + "mall/cart/add",
    "fastAddCart" : baseUrl2 + "mall/cart/fastadd",
    "homeChangeCart" : baseUrl2 + "mall/cart/update",
    "homeDelCart" : baseUrl2 + "mall/cart/delete",
    "homeGetCartList" : baseUrl2 + "mall/cart/index",
    "homeGetCartCount" : baseUrl2 + "mall/cart/goodscount",
    "homeCheckedCart" : baseUrl2 + "mall/cart/checked",
    "homeCheckoutCart" : baseUrl2 + "mall/cart/checkout",

    // 用户中心
    // "homeGetUserDefault" : baseUrl + "user/get_user_default", // 默认页面
    "homeGetUserIndex" : baseUrl2 + "mall/user/index", // 默认页面
    // "homeGetUserOrder" : baseUrl + "user/get_user_order", // 默认页面
    "homeGetUserOrder" : baseUrl2 + "mall/order/list", // 默认页面

    // 用户收货地址
    'getAddressList' : baseUrl2 + "mall/address/list",
    'addressSave' : baseUrl2 + "mall/address/save",
    'editAddress' : baseUrl2 + "mall/address/update",
    'delAddress' : baseUrl2 + "mall/address/delete",
    'setDefaultAddress' : baseUrl2 + "mall/address/set_default",

    // 获取物流信息
    'homeGetDeliveryList' : baseUrl + "order/get_user_delivery",

    // 订单评论
    'homeGetOrderInfoByOrderId' : baseUrl + "order/get_order_info_by_order_id",  // 根据订单ID获取订单信息
    // 'homeGetCommentList' : baseUrl + "order/get_comment_list",  // 根据订单ID获取订单信息
    'homeAddComment' : baseUrl + "order/comment",  // 添加评论
    // 'homeCommentImage' : baseUrl + "comment/comment_image",  // 图片上传 评论
    'homeUploadImage' : baseUrl2 + 'api/storage/upload', //图片上传,
    // 修改订单状态
    'homeChangeOrderStatus' : baseUrl + "order/change_order_status",
    'homeOrderRefund' : baseUrl + "order/refund", // 申请售后
    'homeOrderRefundDelivery' : baseUrl + "order/refund_delivery_no", // 售后发送快递单号

    // 预生成订单数据
    'homeGetOrderDetail' : baseUrl + "order/detail",
    // 获取询价单详情
    'getInquiryDetail': baseUrl2 + 'mall/order/detail',
    // 获取报价单列表
    "getReportList": baseUrl2 + 'mall/order/inquiry/',
    // 生成订单
    'homeCreateOrder' : baseUrl2 + "mall/order/submit",
    'homeGetOrderInfoByOrderNo' : baseUrl + "order/get_order_info_by_order_no",  // 根据订单号获取订单信息
    'homePayOrder' : baseUrl + "order/pay",  // 支付订单
    'homeCheckWxpayNative' : baseUrl + "order/check_wxpay_native",  // 查下订单支付情况
    'OrderH5pay' : baseUrl + "order/h5pay",//微信h5
    'OrderWxNativePay' : baseUrl + "order/h5pay",//微信native
    'OrderAliPcPay' : baseUrl + "order/aliPcPay",//aliPcPay

    // 取消订单
    'OrderCancel' : baseUrl + "order/cancel",
    // 删除订单
    'OrderDelete' : baseUrl2 + "mall/order/delete",
    // 退款取消订单
    'OrderRefund' : baseUrl + "order/refund",
    // 确认收货
    'OrderConfirm' : baseUrl + "order/confirm",
    // 发布PDF
    'PubPDF' : baseUrl + "order/publish/",
    // 导出excel
    'exportXLS': baseUrl + "order/export/xls",
    'download': baseUrl + "order/export/download",


    // 提现 cash
    'homeGetCashLog' : baseUrl + "cash/get_cash_log",
    'homeAddCashLog' : baseUrl + "cash/add_cash",

    // 无压缩裁剪上传
    'homeAutoUpload' : baseUrl +"auto/auto_upload",
    // 团购列表
    'homeGrouponList' : baseUrl +"groupon/list",
    /**
     * 公共接口
     * @author hg <www.qingwuit.com>
     */

    // 获取协议数据(根据ename)
    "homeGetAgreementInfo" : baseUrl + "api/get_agreement_info",

    // 获取省市区信息
    "homeGetAreaList" : baseUrl + "region/list",

    // 获取PC商品分类信息
    "homeGetGoodsClassList" : baseUrl + "api/get_goods_class_list",

    // 获取PC 幻灯片或者广告
    "homeGetBanner" : baseUrl + "api/get_banner",

}